"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _help_1_ = _interopRequireDefault(require("../images/help_1_8.gif"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var stuffs = {
  id: "stuffs",
  title: {
    en: "Lesson 8 (Stuffs)",
    de: "Lektion 8 (Zeug)"
  },
  content: {
    en: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("img", {
      src: _help_1_.default,
      alt: "",
      style: {
        width: "390px",
        height: "274px",
        display: "block",
        margin: "16px auto"
      }
    }), /*#__PURE__*/_react.default.createElement("p", null, "In the Ferentus world, depending on other users and teamwork, it will determine the difficultiy in your party play."), /*#__PURE__*/_react.default.createElement("p", null, "Make sure to maintain a good relationship and continue to meet new players who can help you in the Ferentus world, it is very important part of the game."), /*#__PURE__*/_react.default.createElement("p", null, "Go out of the town and search for different monsters, and terrain and learn them, so that you can be a step closer to being a hero in the continent of Rog."))
  }
};
var _default = stuffs;
exports.default = _default;